<template>
	<sf-content-layout class="mapping-program-process">
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_('SWCC000386')" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:titleEnd>
			<sf-button v-if="isButton_(scrId, 'AD')" :onClick="registerMapping">{{ getMessage_('SWCC000245') }}</sf-button>
		</template>
		<template v-slot:content>
			<center-content :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import CenterContent from './Content/Content';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MappingProgramProcess/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: { CenterContent },
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		registerMapping() {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					type: 'create',
					show: true,
					selectedRow: { regId: 'ADMIN' }
				}
			});
		},
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>

<style></style>
